import { createAuthClient } from 'better-auth/vue'

/**
 * Better Auth client — matches the default /api/auth base path.
 * Use authClient.useSession(useFetch) for SSR-safe session in layouts.
 */
export const authClient = createAuthClient()
